import React, { useEffect, useState } from "react";
import { Row, Col, Form, Image, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Card from "../Card";
import axios from "axios";
import imgsuccess from "../../assets/images/pages/img-success.png";
import Select from "react-select";
import "../../assets/css/stepper.css";
import { getUserList } from "../../services/Users-services";
import {
  addSite,
  getSiteDetails,
  updateSite,
} from "../../services/Organization-services";
import { getLocalStorageData } from "../../services/axiosComponent";

import {
  callToast,
  showErrorMessages,
} from "../../services/utilityFunctions.js";
import {
  getCountryList,
  getCityList,
  getStateList,
} from "../../services/system.js";
import { useGlobalState } from "../../services/hostelConst";
import { selectStyle } from "../../services/constant";
const AddSiteForm = ({ refresh, navigate }) => {
  const { closeModal, masterTableState, updateMasterTable, modalState } =
    useGlobalState();
  const id = modalState.id;

  const [step, setStep] = useState(1);
  const myButton = document.getElementById("myToastButton");
  const [loadingData, setLoadingData] = useState(modalState.isEditing);

  const prepareFormData = (data = null) => {
    return {
      // Site Info
      name: data == null ? "" : data.NAME,
      description: data == null ? "" : data.DESCRIPTION,
      managerId: {
        value: data == null ? "" : data["_MANAGER"],
        label: data == null ? "" : data["MANAGER"],
      },
      regionId: {
        value: data == null ? "" : data["_REGION"],
        label: data == null ? "" : data["REGION"],
      },

      // Address Info
      addressLine1: data == null ? "" : data["_LOCATION_"]["ADDRESS LINE 1"],
      addressLine2: data == null ? "" : data["_LOCATION_"]["ADDRESS LINE 2"],
      city: {
        value: data == null ? "" : data["_LOCATION_"]["_CITY"],
        label: data == null ? "" : data["_LOCATION_"]["CITY"],
      },
      country: {
        value: data == null ? "" : data["_LOCATION_"]["_COUNTRY"],
        label: data == null ? "" : data["_LOCATION_"]["COUNTRY"],
      },
      postalCode: data == null ? "" : data["_LOCATION_"]["POSTAL CODE"],
      state: {
        value: data == null ? "" : data["_LOCATION_"]["_STATE"],
        label: data == null ? "" : data["_LOCATION_"]["STATE"],
      },
    };
  };

  const [formData, setFormData] = useState(prepareFormData());

  const getSiteDetailsData = async (id) => {
    setLoadingData(true);
    var res = await getSiteDetails(id);
    if (res.status == "success") {
      console.log(res.data, "res in site details");
      setFormData(prepareFormData(res.data));
    } else {
      showErrorMessages({ data: res, navigate });

      closeModal();
    }
    setLoadingData(false);
  };

  const [loadingManagerOptions, setLoadingManagerOptions] = useState(false);
  const [loadingCityOptions, setLoadingCityOptions] = useState(false);
  const [loadingCountryOptions, setLoadingCountryOptions] = useState(false);
  const [loadingStateOptions, setLoadingStateOptions] = useState(false);
  const [managerOptions, setManagerOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [managerName, setManagerName] = useState("");
  const [countryId, setCountryId] = useState("");
  const [stateId, setStateId] = useState("");
  const [cityId, setCityId] = useState("");
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const getStateListOptions = async (name = null, countryId) => {
    setLoadingStateOptions(true);
    const res = await getStateList({
      query: name,
      countryId: countryId,
    });
    if (res.status == "success") {
      var list = [];
      if (res.data.entityList.length == 0 && name == null) {
        console.log("name", name);
        setErrors({ ...errors, country: "No States found for this Country." });
      }
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item.NAME,
        });
      });
      setStateOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoadingStateOptions(false);
  };

  const getCityListOptions = async (name = null, stateId) => {
    setLoadingCityOptions(true);
    const res = await getCityList({
      query: name,
      stateId: stateId,
      countryId: countryId,
    });
    if (res.status == "success") {
      var list = [];
      if (res.data.entityList.length == 0 && name == null) {
        setErrors({
          ...errors,
          state: "No Cities found for this State.",
        });
      }
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item.NAME,
        });
      });
      setCityOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoadingCityOptions(false);
  };
  const getCountryListOptions = async (name = null) => {
    setLoadingCountryOptions(true);
    const res = await getCountryList({ query: name });
    console.log(res, "res in country list");
    if (res != "fail") {
      var list = [];
      console.log(res.data);
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item.NAME,
        });
      });
      setCountryOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoadingCountryOptions(false);
  };
  const getManagerOptions = async () => {
    setLoadingManagerOptions(true);
    const res = await getUserList({
      query: managerName,
      status: "Y",
    });
    if (res != "fail") {
      var list = [];
      if (res.data.entityList.length == 0) {
        regionOptions.map((item) => {
          console.log(item, "ddd");
          console.log("");
          setFormData((prev) => ({
            ...prev,
            managerId: { value: item.value, label: item.label },
          }));
        });
      }
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item["NAME"],
        });
      });

      console.log("manager options", list);
      setManagerOptions(list);
    } else {
      showErrorMessages({ data: res, navigate: navigate });
    }
    setLoadingManagerOptions(false);
  };
  useEffect(() => {
    getRegionList();
    getManagerOptions();
    getCountryListOptions();
    if (modalState.isEditing == true) {
      getSiteDetailsData(id);
    }

    return () => {};
  }, []);
  useEffect(() => {
    if (countryId) {
      getStateListOptions(null, countryId);
    }

    return () => {};
  }, [countryId]);
  useEffect(() => {
    if (stateId) {
      getCityListOptions(null, stateId);
    }

    return () => {};
  }, [stateId]);

  const handleChange = (field, value) => {
    if (field == "country") {
      setErrors({ ...errors, state: "", city: "", country: "" });
      setStateOptions([]);
      setCityOptions([]);
      setFormData({
        ...formData,
        [field]: value,
        state: { value: "", label: "" },
        city: { value: "", label: "" },
      });

      if (field == "region") {
        setFormData((prev) => ({
          ...prev,
          managerId: { value: "", label: "" },
        }));
      }
      setStateOptions([]);
      setCityOptions([]);

      return;
    }
    if (field == "state") {
      setCityOptions([]);
      setFormData({
        ...formData,
        [field]: value,
        city: { value: "", label: "" },
      });
      setErrors({ ...errors, city: "", state: "" });
      setCityOptions([]);
      return;
    }
    setFormData({ ...formData, [field]: value });

    setErrors({ ...errors, [field]: "" });
  };

  const validateForm = () => {
    const newErrors = {};

    if (step == 1) {
      if (!formData.name.trim()) {
        newErrors.name = "Name is required";
      }
      if (!formData.description.trim()) {
        console.log("Description is required");
        newErrors.description = "Description is required";
      }
      if (!formData.managerId || !formData.managerId.value) {
        newErrors.managerId = "Manager is required";
      }
      if (!formData.regionId || !formData.regionId.value) {
        newErrors.regionId = "Region is required";
      }
    } else if (step == 2) {
      if (!formData.addressLine1.trim()) {
        newErrors.addressLine1 = "Address Line 1 is required";
      }
      if (!formData.addressLine2.trim()) {
        newErrors.addressLine2 = "Address Line 2 is required";
      }

      if (!formData.postalCode.trim()) {
        newErrors.postalCode = "Postal Code is required";
      } else if (!/^\d{6}$/.test(formData.postalCode.trim())) {
        newErrors.postalCode = "Invalid postal code format";
      }
    } else if (step == 3) {
      if (!formData.country.label.trim()) {
        newErrors.country = "Country is required";
      }
      if (!formData.state.label.trim()) {
        newErrors.state = "State is required";
      }
      if (!formData.city.label.trim()) {
        newErrors.city = "City is required";
      }
    }

    // Step 2 validation

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      var dataToSubmit = {
        description: formData.description,
        managerId: formData.managerId.value,
        name: formData.name,
        regionId: formData.regionId.value,
        organizationId:
          getLocalStorageData("profileDetails")["_ORGANIZATION_"]._ID,
        siteLocation: {
          addressLine1: formData.addressLine1,
          addressLine2: formData.addressLine2,
          cityId: formData.city.value,
          countryId: formData.country.value,
          postalCode: formData.postalCode,
          stateId: formData.state.value,
        },
        id: modalState.isEditing ? id : null,
      };

      var res = modalState.isEditing
        ? await updateSite(dataToSubmit)
        : await addSite(dataToSubmit);
      if (res.status == "success") {
        callToast(
          "success",
          "Success",
          modalState.isEditing
            ? "Site Updated Successfully"
            : "Site Added Successfully"
        );
        await refresh({ columnRefresh: false, isLoading: false });
        closeModal();
        updateMasterTable(!masterTableState);
      } else {
        console.log(res, "res in site add");
        var resError = showErrorMessages({
          data: res,
          navigate,
        });
      }
      setLoading(false);
    }
  };
  const handleNextStep = () => {
    if (validateForm()) {
      setStep(step + 1);
    }
  };

  const [isRegionSearchable, setIsRegionSearchable] = useState(true);
  const [regionOptions, setRegionOptions] = useState([]);
  const getRegionList = async () => {
    var data = await JSON.parse(localStorage.getItem("profileDetails"));
    var list = JSON.parse(localStorage.getItem("regionList"));
    if (
      list.length == 1 &&
      list[0].value == data["_REGION"] &&
      data["_REGION_ACCESS_"] == null
    ) {
      handleChange("regionId", {
        value: list[0].value,
        label: list[0].label,
      });
      setIsRegionSearchable(false);
    }
    setRegionOptions(list);
  };

  return (
    <>
      {loadingData ? (
        <center>
          <div class="spinner-border text-primary" role="status">
     
          </div>
        </center>
      ) : (
        <section className="">
          <div className="d-flex  justify-content-center ">
            <div className="w-100 m-3">
              {/* <div
              className="position-absolute top-10 start-20 bg-primary"
              style={{
                left: "5%",
                top: "-10%",
                width: "12%",
                height: "110%",
                backgroundColor: "blue",
              }}
            ></div> */}

              <div className="d-flex h-100">
                <div className="w-100">
                  {/* <div className="d-flex justify-content-start">
                  <strong className="text-primary" style={{ fontSize: "2rem" }}>
                    Sites
                  </strong>
                </div> */}

                  <>
                    <div className="stepper mb-3 ">
                      <div className="d-flex justify-content-between">
                        <div className={`step ${step === 1 ? "active" : ""}`}>
                          Site Info
                        </div>
                        <div className={`step ${step === 2 ? "active" : ""}`}>
                          Address
                        </div>
                        <div className={`step ${step === 3 ? "active" : ""}`}>
                          Location
                        </div>
                      </div>
                    </div>

                    {step === 1 ? (
                      // Step 1: Site Info
                      <>
                        <div className="mb-3 m-4">
                          <label className="form-label">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Site Name"
                            value={formData.name}
                            onChange={(e) =>
                              handleChange("name", e.target.value)
                            }
                          />
                          {errors.name && (
                            <small className="text-danger">{errors.name}</small>
                          )}
                        </div>

                        <div className="mb-3 m-4">
                          <label className="form-label">Description</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Description"
                            value={formData.description}
                            onChange={(e) =>
                              handleChange("description", e.target.value)
                            }
                          />
                          {errors.description && (
                            <small className="text-danger">
                              {errors.description}
                            </small>
                          )}
                        </div>

                        <div className="row mb-3 m-4 me-2 ms-2">
                          <div className="col-md-6">
                            <label className="form-label">Region</label>
                            <Select
                              options={regionOptions}
                              value={
                                formData.regionId.label === ""
                                  ? null
                                  : formData.regionId
                              }
                              onChange={(value) => {
                                handleChange(
                                  "regionId",
                                  value == null
                                    ? { value: "", label: "" }
                                    : value
                                );
                              }}
                              placeholder="Select Region"
                              isSearchable={isRegionSearchable}
                              onInputChange={(inputValue) => {
                                if (inputValue.length > 0) {
                                }
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              filterOption={(option, inputValue) =>
                                option.label
                                  .toLowerCase()
                                  .includes(inputValue.toLowerCase())
                              }
                              styles={selectStyle}
                            />
                            {errors.regionId && (
                              <small className="text-danger">
                                {errors.regionId}
                              </small>
                            )}
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Manager</label>
                            <Select
                              styles={selectStyle}
                              options={managerOptions}
                              value={
                                formData.managerId.label === ""
                                  ? null
                                  : formData.managerId
                              }
                              onChange={(value) =>
                                handleChange(
                                  "managerId",
                                  value == null
                                    ? { value: "", label: "" }
                                    : value
                                )
                              }
                              placeholder="Select Manager"
                              isSearchable
                              onInputChange={(inputValue) => {
                                if (inputValue.length > 0) {
                                  setManagerName(inputValue);
                                  getManagerOptions();
                                }
                              }}
                              noOptionsMessage={() => {
                                return managerOptions.length == 0
                                  ? "No Managers found for this Region"
                                  : "NO Match Found";
                              }}
                              components={
                                loadingManagerOptions
                                  ? {
                                      DropdownIndicator,
                                    }
                                  : null
                              }
                              className="basic-single"
                              classNamePrefix="select"
                              filterOption={(option, inputValue) =>
                                option.label
                                  .toLowerCase()
                                  .includes(inputValue.toLowerCase())
                              }
                            />
                            {errors.managerId && (
                              <small className="text-danger">
                                {errors.managerId}
                              </small>
                            )}
                          </div>
                        </div>

                        <div className="d-flex justify-content-end m-4">
                          <Button onClick={handleNextStep}>Next</Button>
                        </div>
                      </>
                    ) : step === 2 ? (
                      // Step 2: Address
                      <>
                        <div className="mb-3 m-4">
                          <label className="form-label">Address Line 1</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Address Line 1"
                            value={formData.addressLine1}
                            onChange={(e) =>
                              handleChange("addressLine1", e.target.value)
                            }
                          />
                          {errors.addressLine1 && (
                            <small className="text-danger">
                              {errors.addressLine1}
                            </small>
                          )}
                        </div>

                        <div className="mb-3 m-4">
                          <label className="form-label">Address Line 2</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Address Line 2"
                            value={formData.addressLine2}
                            onChange={(e) =>
                              handleChange("addressLine2", e.target.value)
                            }
                          />
                          {errors.addressLine2 && (
                            <small className="text-danger">
                              {errors.addressLine2}
                            </small>
                          )}
                        </div>

                        <div className="mb-3 m-4">
                          <label className="form-label">Postal Code</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Postal Code"
                            value={formData.postalCode}
                            onChange={(e) =>
                              handleChange("postalCode", e.target.value)
                            }
                          />
                          {errors.postalCode && (
                            <small className="text-danger">
                              {errors.postalCode}
                            </small>
                          )}
                        </div>

                        <div className="d-flex justify-content-between m-4">
                          <Button
                            variant="secondary"
                            onClick={() => setStep(1)}
                          >
                            Back
                          </Button>
                          <Button onClick={handleNextStep}>Next</Button>
                        </div>
                      </>
                    ) : (
                      // Step 3: Location
                      <>
                        <div className="mb-3 m-4">
                          <label className="form-label">Country</label>
                          <Select
                            styles={selectStyle}
                            options={countryOptions}
                            value={
                              formData.country.label == ""
                                ? null
                                : formData.country
                            }
                            onChange={(value) => {
                              setCountryId(value.value);

                              setCityId("");
                              setStateId("");
                              handleChange("country", value);
                            }}
                            placeholder="Select Country"
                            isSearchable
                            onInputChange={(inputValue) => {
                              if (inputValue.length > 0) {
                                getCountryListOptions(inputValue);
                              }
                            }}
                            components={
                              loadingCountryOptions
                                ? { DropdownIndicator }
                                : null
                            }
                          />
                          {errors.country && (
                            <small className="text-danger">
                              {errors.country}
                            </small>
                          )}
                        </div>
                        <div className="mb-3 m-4">
                          <label className="form-label">State</label>
                          <Select
                            styles={selectStyle}
                            options={stateOptions}
                            value={
                              formData.state.label == "" ? null : formData.state
                            }
                            onInputChange={(inputValue) => {
                              if (inputValue.length > 0) {
                                getStateListOptions(inputValue, countryId);
                              }
                            }}
                            onChange={(value) => {
                              handleChange("state", value);
                              setStateId(value.value);
                            }}
                            placeholder="Select State"
                            components={
                              loadingStateOptions ? { DropdownIndicator } : null
                            }
                            isSearchable
                          />
                          {errors.state && (
                            <small className="text-danger">
                              {errors.state}
                            </small>
                          )}
                        </div>
                        <div className="mb-3 m-4">
                          <label className="form-label">City</label>
                          <Select
                            styles={selectStyle}
                            options={cityOptions}
                            value={
                              formData.city.label == "" ? null : formData.city
                            }
                            onChange={(value) => {
                              handleChange("city", value);
                              setCityId(value.value);
                            }}
                            placeholder="Select City"
                            isSearchable
                            onInputChange={(e) => {
                              if (e.length > 0) {
                                getCityListOptions(e, stateId);
                              }
                            }}
                            components={
                              loadingCityOptions ? { DropdownIndicator } : null
                            }
                          />
                          {errors.city && (
                            <small className="text-danger">{errors.city}</small>
                          )}
                        </div>

                        <div className="d-flex justify-content-between m-4">
                          <Button
                            variant="secondary"
                            onClick={() => setStep(2)}
                          >
                            Back
                          </Button>
                          <Button
                            type="submit"
                            disabled={loading}
                            onClick={handleSubmit}
                          >
                            {loading ? (
                              <div
                                class="spinner-border text-light"
                                role="status"
                              >
                         
                              </div>
                            ) : (
                              "Submit"
                            )}
                          </Button>
                        </div>
                      </>
                    )}
                  </>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};
const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        class="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
 
      </div>
    </div>
  );
};

export default AddSiteForm;
